module.exports = __webpack_public_path__ + "static/media/unbound4.daaf9632.png";